import React from 'react';
import { EditPanel, CollapsiblePanel } from '../../elements';

export function SurveyEditCollapsiblePanel(props: { children: React.ReactNode; headerText: string; initialIsClosed?: boolean }) {
    return (
        <EditPanel bottomMargin={true} noPadding={true}>
            <CollapsiblePanel heading={{ dark: true, text: props.headerText, initialIsClosed: props.initialIsClosed }}>
                {props.children}
            </CollapsiblePanel>
        </EditPanel>
    );
}
